/**
 * @fileoverview Build the JSON snippet users paste into their MCP client config.
 * @module features/mcp/utils/buildClientConfig
 */

const TOKEN_PLACEHOLDER = '<paste-token-here>'

/**
 * Format the JSON snippet that goes under `mcpServers` in an MCP client's
 * config (Claude Code's `.mcp.json`, Claude Desktop's
 * `claude_desktop_config.json`, Cursor, etc.).
 *
 * Emits the native Streamable HTTP transport (MCP spec 2025-03-26+):
 * a single endpoint, static bearer header, no Node bridge. The previous
 * snippet shelled out to `npx mcp-remote ... --transport sse-only`, which
 * is incompatible with the server now (legacy SSE transport removed) and
 * also did an OAuth-discovery preflight that crashed on our Tomcat 404.
 *
 * Pass `null` for `token` to render a copy-paste-ready template with a
 * placeholder; pass the plaintext token to embed it directly (only safe
 * when the token has just been issued and shown to the user).
 */
export function buildClaudeDesktopConfig(mcpUrl: string, token: string | null): string {
  const tokenValue = token ?? TOKEN_PLACEHOLDER
  const config = {
    mcpServers: {
      abyssblock: {
        type: 'http',
        url: mcpUrl,
        headers: {
          Authorization: `Bearer ${tokenValue}`,
        },
      },
    },
  }
  return JSON.stringify(config, null, 2)
}
